class MonetaryAmount {
  currencyCode: string;

  centAmount: number;

  fractionDigits: number;

  constructor() {
    this.currencyCode = '';
    this.centAmount = 0;
    this.fractionDigits = 0;
  }
}

export default MonetaryAmount;
